import React from 'react';
import { Link } from 'react-router-dom';
import NavRedes from './navRedes';
export default function Footer() {
  return <footer className="site-footer">
        <div className="footer-top"><div><Link to="/" className="wordmark">BOCA DE SAPO</Link><p>Una revista para leer el mundo.</p></div><NavRedes /></div>
        <div className="footer-bottom"><span>ISSN 1852-9909</span><span>Revista indexada en CAICYT y LATINDEX</span><Link to="/contacto">Hablemos ↗</Link></div>
        <p className="footer-legal">Derechos reservados. La reproducción total o parcial requiere la cita bibliográfica correspondiente y/o la autorización de la editora. La dirección no se responsabiliza de las opiniones de los artículos firmados. Los colaboradores aceptan la publicación de sus aportaciones en soporte impreso y digital. BOCADESAPO no retribuye pecuniariamente las colaboraciones.</p>
    </footer>;
}
